import { SelfOrderLabel } from "api/types/order/self_order";

export enum ActionType {
  GET_SELF_ORDER_LABELS_SUCCESS = "GET_SELF_ORDER_LABELS_SUCCESS"
}

interface IGetSelfOrderLabelsSuccess {
  type: ActionType.GET_SELF_ORDER_LABELS_SUCCESS,
  payload: SelfOrderLabel[]
}

export type Action = IGetSelfOrderLabelsSuccess;
